import '.dn{padding-top:222px;}.ssr-plugin'
import '.al{padding-bottom:96px;}.ssr-plugin'
import '.am{padding-left:96px;}.ssr-plugin'
import '.ak{padding-right:96px;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.f{flex-direction:column;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.cy{justify-content:center;}.ssr-plugin'
import '.b5{text-align:center;}.ssr-plugin'
import '.az{min-height:100dvh;}.ssr-plugin'
import '.b1{box-sizing:border-box;}.ssr-plugin'
import '.h{flex:1;}.ssr-plugin'
import '.an{max-width:1280px;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import { styled, Style } from 'inlines'
import { MOBILE, TABLET } from '../utils/breakpoints.js'

type LayoutProps = {
  children: React.ReactNode
  style?: Style
}

export const Layout = ({ children, style }: LayoutProps) => {
  return (
    <styled.div className="dn al am ak e f w cy b5 az b1 h"
      style={{
        [TABLET]: {
          paddingTop: '158px',
          paddingLeft: '48px',
          paddingRight: '48px',
        },
        [MOBILE]: {
          paddingLeft: '16px',
          paddingRight: '16px',
        },
        ...style,
      }}
    >
      <div className="an m e f w cy b5"
      >
        {children}
      </div>
    </styled.div>
  )
}
